import { useChangePassword } from '@api/password';
import { useChangePasswordStore } from '@shared/store/useChangePasswordStore';
import { passwordsMatch } from '../business_logic';

export function useChangePasswordSubmit(
  onSuccess: (message: string) => void,
  onError: (message: string) => void,
  onSuccessNavigate: () => void
) {
  const changePassword = useChangePassword();
  const form = useChangePasswordStore((s) => s.form);
  const setIsSubmitting = useChangePasswordStore((s) => s.setIsSubmitting);
  const reset = useChangePasswordStore((s) => s.reset);

  return () => {
    if (!form.currentPassword || !form.newPassword || !form.confirmPassword) return;

    if (!passwordsMatch(form.newPassword, form.confirmPassword)) {
      onError('New passwords do not match.');
      return;
    }

    if (form.newPassword.length < 8) {
      onError('Password must be at least 8 characters.');
      return;
    }

    setIsSubmitting(true);

    changePassword({
      currentPassword: form.currentPassword,
      newPassword: form.newPassword,
    })
      .then(() => {
        onSuccess('Password changed successfully!');
        setIsSubmitting(false);
        reset();
        onSuccessNavigate();
      })
      .catch((error: Error) => {
        const message = error.message.includes('Invalid current password')
          ? 'Current password is incorrect.'
          : error.message.includes('not available')
            ? 'Password change is not available for this account.'
            : 'Could not change password. Please try again.';
        onError(message);
        setIsSubmitting(false);
      });
  };
}
